import { render, staticRenderFns } from "./DownloadStatistical.vue?vue&type=template&id=47db0858&scoped=true&"
import script from "./DownloadStatistical.vue?vue&type=script&lang=js&"
export * from "./DownloadStatistical.vue?vue&type=script&lang=js&"
import style0 from "./DownloadStatistical.vue?vue&type=style&index=0&id=47db0858&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47db0858",
  null
  
)

export default component.exports